import {
  useQuery,
} from '@tanstack/react-query'

import { resourcefulScenarioRequest } from '../requests'

export function useNoteTemplatesQuery({
  scenarioID,
  initialData,
  queryKey
}) {
  const noteRequests = resourcefulScenarioRequest(
    scenarioID, 'note_templates'
  )

  const noteTemplatesQuery = useQuery({
    queryFn: noteRequests.index,
    queryKey,
    initialData
  })

  const isFetching = noteTemplatesQuery.isFetching

  const isAnyLoading = noteTemplatesQuery.isFetching

  return {
    data: noteTemplatesQuery.data,
    status: noteTemplatesQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
